import { VisitsDatatable } from "datatables/visits"
export default class VisitsIndex extends ApplicationController {
  connect () {
    this.datatable = new VisitsDatatable()
  }
}